export function formatImportErrorMessage(error, fallback = "导入失败") {
  const detail = error?.response?.data?.detail;
  const rawMessage = [
    typeof detail === "string" ? detail : "",
    error?.message,
    String(error || ""),
  ].filter(Boolean).join("\n");

  if (/gmail\.googleapis\.com|Gmail API has not been used|accessNotConfigured|gmail api/i.test(rawMessage)) {
    return [
      "Gmail API 尚未启用，系统没有读取 Gmail 的权限。",
      "请先打开 Google Cloud Console，启用 Gmail API 后等待几分钟，再点击立即导入。",
    ].join("\n");
  }

  if (/network|timeout|failed to fetch|ECONN/i.test(rawMessage)) {
    return `${fallback}：网络连接异常，请稍后重试。`;
  }

  if (typeof detail === "string" && detail.trim()) {
    return `${fallback}：${detail.trim()}`;
  }

  if (detail && typeof detail === "object") {
    return `${fallback}：${detail.message || detail.error || JSON.stringify(detail)}`;
  }

  if (error?.message) {
    return `${fallback}：${error.message}`;
  }

  return fallback;
}
